<template>
  <b-modal :id="`ModalSalvarCenario${id}`">
    <Header mini titulo="SOBRESCREVER CENÁRIO" icone="save" cor="verde" slot="modal-header"/>
    <template>
      <div class="modal-corpo">
        O cenário <b>{{ nomeCenario }}</b> já existe. <br />
        Deseja sobrescrever o cenário?
      </div>
    </template>
    <template slot="modal-footer">
      <BotaoPadrao
        arredondadoEsquerda
        class="botao-modal"
        nome="Cancelar"
        icone="times"
        :click="cancelar"
      />
      <BotaoPadrao
        arredondadoEsquerda
        class="botao-modal"
        nome="Salvar"
        icone="check"
        :click="handleClick"
        cor="verde"
      />
    </template>
  </b-modal>
</template>

<script>
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";
import Header from "@/components/ModalComponente/Header.vue";

export default {
  name: "ModalSalvar",
  components: {
    BotaoPadrao,
    Header
  },
  props: {
    submitSalvarCenario: Function,
    nomeCenario: String,
    id: Number
  },
  created() {
    window.addEventListener("keydown", this.handleKey);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKey);
  },

  methods: {
    handleKey(event) {
      let modal = document.getElementById(`ModalSalvarCenario${this.id}`);
      if (modal.classList.contains("show")) {
        if (event.key === "Enter") {
          this.submitSalvarCenario();
          this.$root.$emit("bv::hide::modal", `ModalSalvarCenario${this.id}`);
        }
      }
    },
    handleClick() {
      this.submitSalvarCenario();
      this.$root.$emit("bv::hide::modal", `ModalSalvarCenario${this.id}`);
    },
    cancelar() {
      this.$root.$emit("bv::hide::modal", `ModalSalvarCenario${this.id}`);
    }
  }
};
</script>

<style lang="scss">
.modal-cabecalho {
  display: flex;
  flex-direction: column;
  align-items: center !important;
  justify-content: center;
}
.modal-cabecalho-interno {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.modal-icone-salvar {
  font-size: 40px;
  margin: 5px 0;
  color: #28a745;
}
.modal-corpo {
  text-align: center;
}
.botao-modal {
  margin: 0 0 0 10px !important;
}
</style>
